import { Grid, MenuItem, TextField } from '@mui/material';
import { IAsset } from '../../../../../../Interfaces/Asset/IAsset';
import { IMortgageAsset } from '../../../../../../Interfaces/Asset/IMortgageAsset';
import { IRealEstateAsset } from '../../../../../../Interfaces/Asset/IRealEstateAsset';
import { ITestamentAssetsViewProps } from '../../../../../../Interfaces/Asset/ITestamentAssetsViewProps';

type MortgageAssetViewProps = ITestamentAssetsViewProps<IMortgageAsset> & {
  realEstateAssets: IAsset[];
};

export function MortgageAssetView({
  asset,
  setAsset,
  realEstateAssets,
}: MortgageAssetViewProps) {
  const realEstates = realEstateAssets as IRealEstateAsset[];
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label='Gesamtbetrag der Hypothek in Euro'
          size='small'
          value={asset.data.value || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                value: Number(event.target.value),
              },
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Beliehenes Objekt'
          select
          size='small'
          value={asset.data.idRealEstate || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                idRealEstate: Number(event.target.value),
              },
            })
          }
          fullWidth
        >
          <MenuItem value={''}>Bitte wählen</MenuItem>
          {realEstates.map(re => (
            <MenuItem key={re.idAsset} value={re.idAsset}>
              {re.data.Street}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Sonstige Informationen'
          rows={2}
          size='small'
          multiline
          value={asset.data.notes || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                notes: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
